import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';


@Component({
  selector: 'exemplos',
  templateUrl: './exemplos.component.html',
  styleUrls: ['./exemplos.component.css']
})
export class ExemplosComponent implements OnInit {

  content: string = 'Oi, Tudo bem?';

  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();

  type: string;
  stacked: any[] = [];

  constructor(private localeService: BsLocaleService) {
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.bsValue, this.maxDate];
    localeService.use('pt-br');
    
    this.stacked.push({
      value: Math.floor(50),
      type: 'danger',
      label: 'TMO 50%'
    });
  
    this.stacked.push({
      value: Math.floor(50),
      type: 'success',
      label: 'TMA 50%'
    });
  }


  noResult = false;
  errorMessage: string = "Nenhum resultado encontrado";

  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  //Reactive forms
  stateCtrl = new FormControl();

  myForm = new FormGroup({
    state: this.stateCtrl
  });
  states = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Dakota',
    'North Carolina',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming'
  ];

  ngOnInit() {

  }

}
